// PHASE 8: Personalized encouragement
import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function FinalReadinessFeedbackPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="🚀"
      heading={t('pages.onboarding.v2.finalReadinessFeedback.heading')}
      text={t('pages.onboarding.v2.finalReadinessFeedback.description')}
      onSubmit={handleSubmit}
    />
  )
}
